import { PayrollDashboard, PayrollRuns, PayrollRunForm, PayrollPayslips, PayrollReports, PayrollSettings } from '../pages/payroll';

export const payrollRoutes = [
  {
    path: '/payroll',
    element: <PayrollDashboard />,
    meta: {
      title: 'Payroll Dashboard',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'read'
      }
    }
  },
  {
    path: '/payroll/runs',
    element: <PayrollRuns />,
    meta: {
      title: 'Payroll Runs',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'read'
      }
    }
  },
  {
    path: '/payroll/runs/new',
    element: <PayrollRunForm />,
    meta: {
      title: 'New Payroll Run',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'create'
      }
    }
  },
  {
    path: '/payroll/runs/:id',
    element: <PayrollRunForm />,
    meta: {
      title: 'Payroll Run Details',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'read'
      }
    }
  },
  {
    path: '/payroll/runs/:id/edit',
    element: <PayrollRunForm />,
    meta: {
      title: 'Edit Payroll Run',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'update'
      }
    }
  },
  {
    path: '/payroll/payslips',
    element: <PayrollPayslips />,
    meta: {
      title: 'Payslips',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'read'
      }
    }
  },
  {
    path: '/payroll/reports',
    element: <PayrollReports />,
    meta: {
      title: 'Payroll Reports',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'read'
      }
    }
  },
  {
    path: '/payroll/settings',
    element: <PayrollSettings />,
    meta: {
      title: 'Payroll Settings',
      requiresAuth: true,
      permissions: {
        resource: 'payroll',
        action: 'update'
      }
    }
  }
];